// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MPA2H","question":"styles_question__2MUn8","description":"styles_description__3x1hA"};